export default __webpack_public_path__ + "static/pragicts-automation-services-it-services-management-b035bf2d4546de3f863e5069ece3431f.jpg";